import axios from '@/api/axios'

const getStore = (id) => {
  return axios.get(`/stores/${id}`)
}

const addStores = (objects) => {
  return axios.post(`/stores`, objects)
}

const updateStores = (store) => {
  return axios.put(`/stores/${store.id}`, store)
}

const deleteStore = (id) => {
  return axios.delete(`/stores/${id}`)
}

const getStoresList = (params) => {
  return axios.get(`/stores/listForAdmin`, {params})
}

export default {
  addStores,
  getStore,
  updateStores,
  deleteStore,
  getStoresList,
}
